import React from 'react'
import { parseISO } from 'date-fns'

import { CourseTypes } from 'enum'
import { IEnrolModel } from 'models/enrol.model'
import { IRequestCourseModel } from 'models/requestCourse.model'
import { Item, ItemLMS, ItemDNC } from '../components/types'

interface Props {
  lms: IEnrolModel[]
  dnc: IRequestCourseModel[]
  selected?: CourseTypes | null
}

export const useMergeApplications = ({ lms, dnc, selected }: Props) => {
  const data: Item[] = React.useMemo(() => {
    const lmsMapped =
      ((!selected || selected === CourseTypes.LMS) &&
        lms.map((enrol): ItemLMS => {
          const { id, user, course, state, stateAdmin, createdAt } = enrol
          return {
            id: Number(id),
            user,
            type: CourseTypes.LMS,
            course: course.name,
            state,
            stateAdmin,
            data: enrol,
            createdAt,
          }
        })) ||
      []

    const dncMapped =
      ((!selected || selected === CourseTypes.DNC) &&
        dnc.map((requestCourse): ItemDNC => {
          const { id, user, name, state, stateAdmin, createdAt } = requestCourse
          return {
            id: Number(id),
            user,
            type: CourseTypes.DNC,
            course: name,
            state,
            stateAdmin,
            data: requestCourse,
            createdAt,
          }
        })) ||
      []

    const array = [...lmsMapped, ...dncMapped]
    return array.sort((a, b) => {
      const aCreatedAt = a.createdAt
      const bCreatedAt = b.createdAt
      if (aCreatedAt && bCreatedAt)
        return +parseISO(bCreatedAt) - +parseISO(aCreatedAt)
      return 0
    })
  }, [lms, dnc, selected])
  return data
}

export default useMergeApplications
